import { ReactNode, useContext } from 'react';
import { MultiSelectContext } from './multi-select-context';
import './multi-select.scss';

type Props = {
    children: (values: string[]) => ReactNode;
    placeholder?: ReactNode;
};
export const MultiSelectValues = ({ children, placeholder }: Props) => {
    const { values } = useContext(MultiSelectContext);

    if (!values.length && placeholder) {
        return placeholder;
    }

    return <div className="multi-select__values">{children(values)}</div>;
};
